import "./OverlayComp.css";
import { defineComponent as o, openBlock as r, createElementBlock as t, normalizeClass as s, renderSlot as a, createCommentVNode as n } from "vue";
import { _ as l } from "./_plugin-vue_export-helper.dad06003.js";
const p = o({
  name: "overlay-comp",
  props: {
    active: {
      type: Boolean,
      required: !0,
      default: !1
    }
  },
  computed: {
    classes() {
      return {
        "overlay-comp": !0
      };
    }
  }
});
function c(e, m, i, u, _, d) {
  return e.active ? (r(), t("div", {
    key: 0,
    class: s(e.classes)
  }, [
    a(e.$slots, "default")
  ], 2)) : n("", !0);
}
const C = /* @__PURE__ */ l(p, [["render", c]]);
export {
  C as OverlayComp
};
//# sourceMappingURL=OverlayComp.js.map
